 import React from 'react';
 import ReactDOM from 'react-dom';

import HelloWorldApp from './App';

ReactDOM.render(<HelloWorldApp />, document.getElementById('root'))